import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'
import { CSSTransitionGroup } from 'react-transition-group'
import { injectIntl } from 'react-intl'

import GameInfo from './GameInfo'
import SequenceForm from './SequenceForm'
import Sequence from './Sequence'

import './GameSequence.css'

class GameSequence extends Component {

  state = {
    gameInfo: false,
    realtime: this.props.realtime,
    play: this.props.play,
    metronome: true,
    sound: this.props.sound,
    nBars: +this.props.bases.barsPerLine,
    barReps: 1,
    bpm: 80,
    basesSel: Object.values(this.props.bases.options),
    supsSel: Object.values(this.props.supIndexes.options),
    subsSel: Object.values(this.props.subIndexes.options)
  }

  handleGameInfoChange = (gameInfo) => { this.setState({ gameInfo: gameInfo }) }
  handleRealtimeChange = (realtime) => { this.setState({ realtime: realtime }) }
  handlePlayChange = (play) => { this.setState({ play: play }) }
  handleMetronomeChange = (metronome) => { this.setState({ metronome: metronome }) }
  handleSoundChange = (sound) => { this.setState({ sound: sound }) }
  handleNBarsChange = (nBars) => { this.setState({ nBars: +nBars }) }
  handleBarRepsChange = (barReps) => { this.setState({ barReps: +barReps }) }
  handleBpmChange = (bpm) => { this.setState({ bpm: +bpm }) }
  handleNewSequence = () => { this.setState(this.state) }
  handleBasesSupsSubsChange = (arr, value) => {
    this.setState((prevState, props) => {
      const arrSel = prevState[arr], i = arrSel.indexOf(value)
      return { [arr]: i >= 0 ? 
                        arrSel.length > 1 ? [...arrSel.slice(0, i), ...arrSel.slice(i + 1)] : arrSel
                        :
                        [...arrSel, value] }
    })
  }
  
  render() {
    return (
      <div className="gamesequence-container">
        <SequenceForm
          gameName={this.props.name[this.props.intl.locale].replace(/\n/g,' ')}
          bases={this.props.bases}
          sups={this.props.supIndexes}
          subs={this.props.subIndexes}
          gameInfo={this.state.gameInfo}
          realtime={this.state.realtime}
          play={this.state.play}
          metronome={this.state.metronome}
          sound={this.state.sound}
          nBars={this.state.nBars}
          barReps={this.state.barReps}
          bpm={this.state.bpm}
          basesSel={this.state.basesSel}
          supsSel={this.state.supsSel}
          subsSel={this.state.subsSel}
          onGameInfoChange={this.handleGameInfoChange}
          onRealtimeChange={this.handleRealtimeChange}
          onPlayChange={this.handlePlayChange}
          onMetronomeChange={this.handleMetronomeChange}
          onSoundChange={this.handleSoundChange}
          onNBarsChange={this.handleNBarsChange}
          onBarRepsChange={this.handleBarRepsChange}
          onBpmChange={this.handleBpmChange}
          onNewSequence={this.handleNewSequence}
          onBasesSupsSubsChange={this.handleBasesSupsSubsChange}
        />
        <CSSTransitionGroup component="div" className="game-info-container"
          transitionName="fadein"
          transitionEnterTimeout={500}
          transitionLeave={false}
          transitionLeaveTimeout={300}>
          {this.state.gameInfo && (
            <GameInfo
              gameName={this.props.name[this.props.intl.locale].replace(/\n/g,' ')}
              gameInfo={this.props.information[this.props.intl.locale]}
            />
          )}
        </CSSTransitionGroup>
        <MediaQuery maxWidth={575}>
          <Sequence
            gameName={this.props.name[this.props.intl.locale].replace(/\n/g,' ')}
            bases={this.props.bases}
            sups={this.props.supIndexes}
            subs={this.props.subIndexes}
            gameInfo={this.state.gameInfo}
            realtime={this.state.realtime}
            play={this.state.play}
            metronome={this.state.metronome}
            sound={this.state.sound}
            nBars={this.state.nBars}
            barReps={this.state.barReps}          
            barsPerLine={1}
            abcScale={this.props.bases.type === 'abc' ?
                        (this.state.realtime ? this.props.bases.abcScale.rt.cellP : this.props.bases.abcScale.st.cellP)
                        : 1}
            bpm={this.state.bpm}
            basesSel={this.state.basesSel}
            supsSel={this.state.supsSel}
            subsSel={this.state.subsSel}
          />
        </MediaQuery>
        <MediaQuery minWidth={576} maxWidth={767}>
          <Sequence
            gameName={this.props.name[this.props.intl.locale].replace(/\n/g,' ')}
            bases={this.props.bases}
            sups={this.props.supIndexes}
            subs={this.props.subIndexes}
            gameInfo={this.state.gameInfo}
            realtime={this.state.realtime}
            play={this.state.play}
            metronome={this.state.metronome}
            sound={this.state.sound}
            nBars={this.state.nBars}
            barReps={this.state.barReps}          
            barsPerLine={2}
            abcScale={this.props.bases.type === 'abc' ?
                        (this.state.realtime ? this.props.bases.abcScale.rt.cellL : this.props.bases.abcScale.st.cellL)
                        : 1}
            bpm={this.state.bpm}
            basesSel={this.state.basesSel}
            supsSel={this.state.supsSel}
            subsSel={this.state.subsSel}
          />
        </MediaQuery>
        <MediaQuery minWidth={768}>
          <Sequence
            gameName={this.props.name[this.props.intl.locale].replace(/\n/g,' ')}
            bases={this.props.bases}
            sups={this.props.supIndexes}
            subs={this.props.subIndexes}
            gameInfo={this.state.gameInfo}
            realtime={this.state.realtime}
            play={this.state.play}
            metronome={this.state.metronome}
            sound={this.state.sound}
            nBars={this.state.nBars}
            barReps={this.state.barReps}          
            barsPerLine={+this.props.bases.barsPerLine}
            abcScale={this.props.bases.type === 'abc' ?
                        (this.state.realtime ? this.props.bases.abcScale.rt.pc : this.props.bases.abcScale.st.pc)
                        : 1}
            bpm={this.state.bpm}
            basesSel={this.state.basesSel}
            supsSel={this.state.supsSel}
            subsSel={this.state.subsSel}
          />
        </MediaQuery>
      </div>
    )
  }
}

GameSequence.propTypes = {
  realtime: PropTypes.bool,
  play: PropTypes.bool,
  sound: PropTypes.bool,
  bases: PropTypes.object,
  subIndexes: PropTypes.object,
  supIndexes: PropTypes.object
}

GameSequence.defaultProps = {
  realtime: false,
  play: true,
  sound: false,
  bases: { options: [0], tag: 'Bases' },
  subIndexes: { options: [], tag: 'Superindexes' },
  supIndexes: { options: [], tag: 'Subindexes' }
}

export default injectIntl(GameSequence)


// WEBPACK FOOTER //
// ./src/components/GameSequence.js